import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { Stack } from "@mui/material";
// components
import {
  ConfirmationModal,
  CustomPagination,
  StyledDataGrid,
} from "../../../components";
import { TipFormModel } from ".";
// hooks
import useVisible from "../../../../../hooks/useVisible";
import useResponse from "../../../../../hooks/useResponse";
import useQuery from "../../../../../hooks/useQuery";

import * as toast from "../../../../../Toast";
// utils
import trimObjectValues from "../../../../../utils/trimObject";

function ListingTable({
  columns,
  // onEditClick,
  onDetail,
  deleteRecord,
  updateRecord,
  controller,
  refreshState,
  result = [],
  pages = 0,
  deleteModelTitle = "",
}) {
  const [isDeleteMode, toggleDeleteMode] = useVisible();
  const [isEditMode, toggleEditMode] = useVisible();
  const [state, dispatch] = useResponse();
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState(result);
  const [totalPages, setTotalPages] = useState(pages);
  const [tipId, setTipId] = useState();
  // const [showOld, setShowOld] = useSessionStorage("showOldTip", true);
  const [queryParams, setQueryParams] = useQuery();

  let page = queryParams.get("page") ? parseInt(queryParams.get("page")) : 1;
  page = page - 1;

  const fetchData = useCallback(
    async ({ page }) => {
      try {
        setLoading(true);
        const response = await controller({
          page: page,
          limit: 10,
        });
        const { data } = await response.data;
        setData(data.result);
        setTotalPages(data.total);
      } catch (ex) {
        toast.error(ex.response.statusText);
      }
      setLoading(false);
    },
    [controller]
  );

  useEffect(() => {
    fetchData({ page: page });
  }, [fetchData, page]);

  useEffect(() => {
    if (refreshState) fetchData({ page: page });
  }, [refreshState, fetchData, page]);

  // const toggleShowOld = () => {
  //   setShowOld(!showOld);
  // };

  const handleCellClick = (params) => {
    const row = params.row;
    const value = params.field;
    if (value === "edit") {
      setTipId(row.id);
      return toggleEditMode();
    }

    if (value === "delete") {
      setTipId(row.id);
      return toggleDeleteMode();
    }

    return onDetail(row.id);
  };

  const handleDeleteConfirm = async () => {
    dispatch.sendingRequst();
    try {
      const response = await deleteRecord(tipId);
      const data = await response.data;
      toggleDeleteMode();

      // refetch data again
      fetchData({ page: page });

      toast.success(data.message);
      dispatch.successResponse(data.message);
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 409
      ) {
        dispatch.gotError(ex.response.data.message);
        toast.error(ex.response.data.message);
      }
    }
  };

  const handleEditConfirm = async (tipData) => {
    dispatch.sendingRequst();
    try {
      const trimTipData = trimObjectValues(tipData);
      const publishedAt = moment(trimTipData.publishedAt).format("YYYY-MM-DD");
      trimTipData.publishedAt = new Date(publishedAt);
      const response = await updateRecord(tipId, trimTipData);
      const data = await response.data;
      toggleEditMode();

      // refetch data again
      fetchData({ page: page });

      toast.success(data.message);
      dispatch.successResponse(data.message);
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status <= 409
      ) {
        dispatch.gotError(ex.response.data.message);
        toast.error(ex.response.data.message);
      }
    }
  };

  const tipItem = data.filter((tip) => tip.id === tipId)[0];

  const initialValues = {
    tipTitle: "",
    isPublished: false,
    publishedAt: moment().format("YYYY-MM-DDTHH:mm"),
  };
  if (tipItem) {
    initialValues.tipTitle = tipItem.tipTitle;
    initialValues.isPublished = tipItem.isPublished;
    initialValues.publishedAt = moment(tipItem.publishedAt).format(
      "YYYY-MM-DDTHH:mm"
    );
  }

  return (
    <>
      <ConfirmationModal
        title={deleteModelTitle}
        showModal={isDeleteMode}
        toggleModal={() => {
          toggleDeleteMode();
          dispatch.reset();
        }}
        onConfirm={handleDeleteConfirm}
        loading={state.loading}
        error={state.error}
      />
      {/* <Stack
        style={{
          display: "flex",
          justifyContent: "center",
          alignSelf: "end",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox checked={!showOld} onClick={toggleShowOld} size="small" />
          }
          label="Show Old Tips"
        />
      </Stack> */}
      <TipFormModel
        title="Edit Tip"
        showModal={isEditMode}
        toggleModal={() => {
          toggleEditMode();
          dispatch.reset();
        }}
        onSubmit={handleEditConfirm}
        initialValues={initialValues}
        state={state}
        isCreated={false}
      />
      <StyledDataGrid
        rows={data}
        columns={columns}
        rowCount={totalPages}
        pageSize={10}
        rowsPerPageOptions={[10]}
        page={page}
        onPageChange={(page) => {
          setQueryParams({ page: page + 1 });
        }}
        disableColumnMenu
        disableColumnSelector
        disableColumnFilter
        paginationMode="server"
        onCellClick={handleCellClick}
        onFilterModelChange={(model) => console.log(model)}
        loading={loading}
        hideFooterSelectedRowCount={true}
        getRowClassName={(params) => {
          return params.row.checkInDone ? "awaiting-response" : "";
        }}
        autoHeight
        components={{
          Pagination: CustomPagination,
          // ColumnSortedAscendingIcon: MdArrowDropUp,
          // ColumnSortedDescendingIcon: MdArrowDropDown,
          NoRowsOverlay: () => (
            <Stack
              height="100%"
              alignItems="center"
              justifyContent="center"
              style={{ fontSize: "1.5rem" }}
            >
              No rows
            </Stack>
          ),
          NoResultsOverlay: () => (
            <Stack
              height="100%"
              alignItems="center"
              justifyContent="center"
              style={{ fontSize: "1.5rem" }}
            >
              No result
            </Stack>
          ),
        }}
      />
    </>
  );
}

export default ListingTable;
